"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformChargebeeApi = void 0;
const ResourcesApi_1 = require("./commons/ResourcesApi");
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
/**
 * Actions related to Chargebee.
 */
class SdPlatformChargebeeApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "chargebee";
    }
    /**
     * Get data required to integrate a chargebee with website.
     * @see {@link https://apidocs.chargebee.com/docs/api/hosted_pages?prod_cat_ver=2} for more.
     * @param body - the parameters of a request.
     * @returns
     */
    hostedPage(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.ChargebeeHostedPage, ResourcesApi_1.Action.Post, "hosted_page", body);
    }
    /**
     * Get data required to integrade hosted page payment method with website.
     * @see {@link https://apidocs.chargebee.com/docs/api/hosted_pages?prod_cat_ver=2#update_payment_method}
     * @param body - the parameters of a request.
     * @returns
     */
    hostedPageUpdatePaymentMethod(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.ChargebeeHostedPageUpdatePaymentMethod, ResourcesApi_1.Action.Post, "hosted_page_update_payment_method", body);
    }
    /**
     * Gets all the required data for opening a chargebee portal session.
     * @see - {@link https://apidocs.chargebee.com/docs/api/portal_sessions?prod_cat_ver=2} for more.
     * @param body - {@link @SdPlatformRequestChargebeePortalSession} body
     * @returns - post response with {@link SdPlatformResponseChargebeePortalSession} data
     */
    portalSession(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.ChargebeePortalSession, ResourcesApi_1.Action.Post, "portal_session", body);
    }
    /**
     * Queries the chargebee plans.
     * @param body - {@link SdPlatformChargebeePlanQueryParameters } body
     * @returns - post response with {@link SdPlatformResponseChargebeePlan} data
     */
    queryChargebeePlans(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.ChargebeeQueryPlan, ResourcesApi_1.Action.Post, "plans/query", body);
    }
    /**
     *
     * @returns Chargebee configuration
     */
    config() {
        return super.__get(SdPlatformRequestId_1.RequestId.ChargebeeConfig, "config");
    }
}
exports.SdPlatformChargebeeApi = SdPlatformChargebeeApi;
//# sourceMappingURL=SdPlatformChargebeeApi.js.map